import { Flex } from '@mantine/core';
import { useCallback, useEffect } from 'react';
import { useCurrentClient } from 'src/clients/context/CurrentClientProvider';
import {
  CONTACTS_SELECTION_MODE,
  ContactsList,
} from 'src/clients/CreateFamily/AddContactsToFamily/ContactsList';
import { Client } from 'src/users';
import { StepProps } from './DrawerFlow';
import DrawerFlowScreenLayout from './DrawerFlowScreenLayout';

type DataWithClient = {
  client?: Client;
};

type SelectClientStepProps<T extends DataWithClient> = StepProps<T> & {
  footer?: React.ReactNode;
  description?: string;
};

export default function SelectClientStep<T extends DataWithClient>(
  props: SelectClientStepProps<T>,
) {
  const { description = 'Select the client you wish to generate a report for', ...stepProps } =
    props;
  const { client } = stepProps.data;
  const { client: currentClient, isClientPage, isLoading } = useCurrentClient();

  const setClient = useCallback(
    (client: Client) => {
      stepProps.clearData();
      stepProps.setData({ ...stepProps.data, client });
    },
    [stepProps],
  );

  useEffect(() => {
    if (currentClient && !client && isClientPage) {
      setClient(currentClient);
    }
  }, [currentClient, client, setClient, isClientPage, isLoading]);

  return (
    <DrawerFlowScreenLayout
      {...stepProps}
      title="Select client"
      description={description}
      canGoForward={client != null && stepProps.canGoForward}
      clientNameSuffix="agenda"
    >
      <Flex direction="column" mih={0} h="100%" style={{ flexShrink: 1, flexGrow: 0 }}>
        <ContactsList
          selectedClients={client ? [client] : []}
          onSelectClient={client => {
            setClient(client);
          }}
          selectionMode={CONTACTS_SELECTION_MODE.SINGLE}
          showAvatar={false}
          showBorder={true}
        />
      </Flex>
    </DrawerFlowScreenLayout>
  );
}
